import "./Legal.scss";
import { Link } from "react-router-dom";
import Nav from "../Nav/Nav";

const TermsOfService = () => {
  return (
    <>
      <div className="legal-header">
        <Nav />
      </div>
      <div className="legal-page">
        <div className="legal-breadcrumb">
          <Link to="/">← Home</Link>
        </div>
        <article className="legal-content">
          <header className="legal-intro">
            <h1>Bayun Terms of Service</h1>
            <p className="effective-date">Effective date: September 9, 2026</p>
            <p>
              These Terms of Service ("Terms") govern your use of Bayun's
              services, including the Bayun Developer Portal, SDKs, and hosted
              service (together, the "Service"), operated by Bayun Systems, Inc.
              ("we," "us," "Bayun"). By registering for an account or using the
              Service, you agree to these Terms.
            </p>
          </header>

          <section>
            <h2>1. Who this is for</h2>
            <p>
              These Terms apply to developers who register for a Bayun account
              and use Bayun SDKs to protect their end users' data within their
              own applications ("Developer," "you"). If you use the Service on
              behalf of a company, you confirm you have authority to bind that
              company to these Terms
            </p>
          </section>

          <section>
            <h2>2. Free use of the hosted service</h2>
            <p>
              Bayun's hosted service is free to use for developers. There are no
              usage limits or restrictions on the free tier by default. You can
              register an account through the Bayun Developer Portal and
              integrate the Bayun SDKs into your applications at no cost.
            </p>
          </section>

          <section>
            <h2>3. Best Effort Service on the free tier</h2>
            <p>
              The free hosted service is provided on a{" "}
              <strong>best effort basis</strong> without any Service Level
              Agreement (SLA). We do not guarantee uptime,
              latency, or availability. We may throttle, rate-limit, or
              otherwise restrict usage for any application at any time, based on
              overall system load or the usage patterns of a specific
              application, at our discretion.
            </p>
          </section>

          <section>
            <h2>4. Commercial agreements (for SLA or self-hosting)</h2>
            <p>
              If you need an SLA or want to avoid free-tier limitations, contact
              us to enter into a commercial agreement. Depending on your
              preference, this may include:
            </p>
            <ul>
              <li>
                An <strong>SLA</strong> for the Bayun-hosted service, or
              </li>
              <li>
                <strong>Server binaries</strong> so you can self-host the
                service on your own cloud infrastructure, or
              </li>
              <li>
                A commercial agreement through a{" "}
                <strong>cloud marketplace</strong> (e.g., AWS, GCP, Azure) for
                hosting the service within your own cloud account.
              </li>
            </ul>
            <p>
              Commercial terms, pricing, and support levels will be set out
              separately in the applicable commercial agreement, or marketplace
              listing as appropriate.
            </p>
          </section>

          <section>
            <h2>5. Acceptable use, abuse, and account review</h2>
            <p>
              We may suspend some or all of your access to the Service if we
              detect signs of potential abuse or spam. Before restoring
              free-tier service, we may ask you for more information about you
              and your application's use case to better understand your usage.
              We may, at our discretion, decline to reinstate service.
            </p>
          </section>

          <section>
            <h2>6. Your responsibilities</h2>
            <p>You are responsible for:</p>
            <ul>
              <li>
                The applications you build using Bayun SDKs, and determine what
                specific data these applications process through the Service.
              </li>
              <li>
                Complying with applicable laws regarding the data you process
                using the Service.
              </li>
              <li>
                Ensuring your actions do not disrupt or abuse the Service
                (including attempts to circumvent throttling or rate limits).
              </li>
              <li>Keeping your Developer Portal credentials secure.</li>
            </ul>
          </section>

          <section>
            <h2>7. Intellectual Property</h2>
            <p>
              Bayun and its licensors retain all rights, title, and interest in
              the Service, SDKs, and any server binaries provided. We grant you
              a limited, non-exclusive, non-transferable license to use the SDKs
              and Service solely to build and operate your applications.
            </p>
          </section>

          <section>
            <h2>8. Changes to the Service or these Terms</h2>
            <p>
              We may update these Terms or make changes to the Service
              (including free-tier limits) from time to time. We will make
              reasonable efforts to communicate material changes. Continued use
              of the Service after changes take effect means you accept the
              updated Terms.
            </p>
          </section>

          <section>
            <h2>9. Disclaimer and limitation of liability</h2>
            <p>
              The Service is provided "as is," without warranties of any kind on
              the free tier, including no warranty of availability or fitness
              for a particular purpose. To the maximum extent permitted by law,
              Bayun is not liable for indirect, incidental, or consequential
              damages arising from use of the free Service.
            </p>
          </section>

          <section>
            <h2>10. Termination</h2>
            <p>
              We may suspend or terminate your access to the free tier at any
              time, with or without cause, including as described in Section 5
              (e.g., suspected abuse). You may stop using the Service at any
              time. Provisions that by their nature should survive termination
              (e.g., IP, disclaimers, limitation of liability) will survive.
            </p>
          </section>

          <section>
            <h2>11. Contact</h2>
            <p>
              Questions about these Terms, or interested in a commercial
              agreement? Contact us through{" "}
              <a href="https://bayun.dev" target="_blank" rel="noopener noreferrer">
                Bayun.dev
              </a>
              .
            </p>
          </section>
        </article>
      </div>
    </>
  );
};

export default TermsOfService;
